import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, ButtonBase, Select, MenuItem, Typography, Avatar } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import NoMatch from '../../home/NoMatch'
import { MatchItem } from '.';
import MSectionHeader from '../../view/MSectionHeader';
import Apis from '../../../network/Apis';
import MatchType from '../../../model/MatchType';

class MatchTeamMember extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            curIdex: 29,
            manager: null,
            players: null,
        };
        console.log('MatchTeamMember', props);
    }

    componentDidMount() {
        let { team, type_id, team_id } = this.props.location.data;
        this.getTeamPlayers(type_id, team ? team.id : team_id);
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    getTeamPlayers = async (type_id, team_id) => {
        let result = await Apis.encryptionTeamPlayer(type_id, team_id);
        console.log('getTeamPlayers', result);
        if (result.code == 200) {
            let data = [];
            if (result.data.player) {
                let players = result.data.player;
                for (let i = 0; i < players.length; i++) {
                    let position = players[i].position;
                    if (!data[position]) {
                        data[position] = [];
                    }
                    data[position].push(players[i]);
                }
            }
            // if (result.data.player) {
            //     let players = result.data.player;
            //     let F = players.filter((item) => {
            //         return item.position == 'F';
            //     });
            // }

            this.setState({ players: data, manager: result.data.manager });
        }
    }

    _handleChange = (value) => {
        console.log('_handleChange', value);
        this.setState({ curIdex: value });
    }

    _getName(name, type) {
        if (type == MatchType.BASKETBALL) {
            if (name == 'F') {
                return '前锋';
            } else if (name == 'SF') {
                return '小前锋';
            } else if (name == 'PF') {
                return '大前锋';
            } else if (name == 'C') {
                return '中锋';
            } else if (name == 'G') {
                return '后卫';
            } else if (name == 'SG') {
                return '得分后卫';
            } else if (name == 'PG') {
                return '组织后卫';
            } else {
                return '其他';
            }
        } else if (type == MatchType.FOOTBALL) {
            if (name == 'F') {
                return '前锋';
            } else if (name == 'M') {
                return '中场';
            } else if (name == 'D') {
                return '后卫';
            } else if (name == 'G') {
                return '守门员';
            } else {
                return '其他';
            }
        }
        return '其他'
    }

    _renderItem(img, name, score) {
        return (
            <Grid container direction='row' alignItems='center' justify='space-between' style={{ marginBottom: 8 }}>
                <Grid container direction='row' alignItems='center' style={{ flex: 1, paddingLeft: 8 }}>
                    <Avatar style={{ width: 30, height: 30 }} src={img} />
                    <Typography style={{ fontSize: 12, color: '#0D0D0D', marginLeft: 8 }}>{name}</Typography>
                </Grid>
                <Typography style={{ fontSize: 12, color: '#0D0D0D', marginRight: 8 }}>{score == 0 ? '' : score}</Typography>
            </Grid>
        );
    }

    render() {
        const { manager, players } = this.state;
        let { type_id } = this.props.location.data;

        var keys = [];
        if (players) keys = Object.keys(players);

        return (
            <Grid style={{ width: '100%' }}>
                <Grid style={{ width: '100%', height: 1, backgroundColor: '#F2F2F2' }}></Grid>
                {
                    manager && <Grid>
                        <MSectionHeader title='主教练' />
                        {
                            this._renderItem(manager && manager.logo, manager && manager.name_zh, '')
                        }
                    </Grid>
                }
                {
                    keys && keys.map((item, i) => (
                        <Grid key={i}>
                            <MSectionHeader title={this._getName(item, type_id)} />
                            {
                                players[item] && players[item].map((val, j) => (
                                    <Grid key={j}>
                                        {
                                            this._renderItem(val.logo, val.name, val.money)
                                        }
                                    </Grid>

                                ))
                            }
                        </Grid>
                    ))
                }
                {/* <MSectionHeader title='后卫' />
                {
                    this._renderItem('https://duihui.duoduocdn.com/zuqiu/liwupu.png', '亚历山德罗·菲奥拉尼', '')
                }
                {
                    this._renderItem('https://duihui.duoduocdn.com/zuqiu/liwupu.png', '哈里姆·梅杜尔', '')
                }
                {
                    this._renderItem('https://duihui.duoduocdn.com/zuqiu/liwupu.png', '伊曼纽尔·斯坦巴赫', '')
                }
                <MSectionHeader title='前锋' />
                {
                    this._renderItem('https://duihui.duoduocdn.com/zuqiu/liwupu.png', '亚历山德罗·菲奥拉尼', '')
                }
                {
                    this._renderItem('https://duihui.duoduocdn.com/zuqiu/liwupu.png', '哈里姆·梅杜尔', '')
                }
                {
                    this._renderItem('https://duihui.duoduocdn.com/zuqiu/liwupu.png', '伊曼纽尔·斯坦巴赫', '')
                } */}
            </Grid >
        );
    }
}

export default withRouter(withStyles((theme) => ({
    button: {
        fontSize: 12,
        backgroundColor: '#FC182B',
        color: '#FFF',
        borderRadius: 4,
        width: 75,
        height: 25,
    },
    tableBodyCell1: {
        padding: theme.spacing(0.5, 1, 0.5, 1),
        fontSize: 10,
        color: '#FC182B'
    },
    tableBodyCell: {
        padding: theme.spacing(0.5, 1, 0.5, 1),
        fontSize: 10,
        color: '#0d0d0d'
    },
    icon: {
        width: 20,
        height: 20,
        marginLeft: 4,
        marginRight: 4,
    }
}))(MatchTeamMember));